import './index.css';

const LoaderComponent = () => {
  const loading = '';
  return (
    <div className="blockUi" id="blockUi">
      <div className="loader-bg" data-text="Loading">
        <div className="loader-track">
          <div className="loader-fill" />
        </div>
      </div>
    </div>
  );
};

export default LoaderComponent;
